import { p as proxyCustomElement, H, h, c as Host } from './p-d3SrgL0G.js';
import { r as removeSSRSlot } from './p-BMgdwhTk.js';
import { d as defineCustomElement$3 } from './p-ku3rkKsm.js';
import { d as defineCustomElement$2 } from './p-D868F-x5.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.7.0
 */

let sidenavMenuId = 0;
const Sidenav = /*@__PURE__*/ proxyCustomElement(class Sidenav extends H {
    constructor() {
        super();
        this.__registerHost();
        this.sidenavMenuId = `tds-sidenav-menu-${sidenavMenuId++}`;
        /**
         * The label for the sidenav, used for accessibility.
         */
        this.label = "Secondary";
        /**
         * The id of the popover.
         */
        this.popoverId = `${this.sidenavMenuId}-popover`;
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: '758538d83080736bedf84f6a11c09d0da88fd3e4', class: "tds-sidenav" }, h("nav", { key: '13d8f58f4811d36943d1a4d39bd615d36d2f37a9', id: this.sidenavMenuId, class: "tds-sidenav-nav", "aria-label": this.label }, h("tds-sidenav-responsive-header", { key: '7532463a17efd11d752baaff7994231f1bfe8503', "popover-id": this.popoverId, label: this.selectedItemLabel }), h("tds-popover-container", { key: '1052556bf4f8aeec02d1b81f7d5c0bbe1ea85ce9', breakpoint: 719, id: this.popoverId, class: "tds-sidenav-collapse", "auto-position": true }, h("div", { key: 'c5077d47b4ed0ebe22f3515cd44ceb68ce49b1ec', class: "tds-sidenav-scroll-container" }, h("slot", { key: '20d8c9a0708c49a6d5bca132a3240fcc8ad8f61c' }))))));
    }
    get el() { return this; }
}, [6, "tds-sidenav", {
        "label": [1],
        "selectedItemLabel": [1, "selected-item-label"],
        "popoverId": [1, "popover-id"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav", "tds-popover-container", "tds-sidenav-responsive-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, Sidenav);
            }
            break;
        case "tds-popover-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "tds-sidenav-responsive-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav.js.map
